document.addEventListener('DOMContentLoaded', () => {
    const topbar = document.querySelector('.topbar');
    const closeBtn = document.querySelector('.topbar-close');

    if (sessionStorage.getItem('topbarClosed') === 'true') {
        topbar.classList.add('closed');
    } else {
        topbar.style.height = topbar.scrollHeight + 'px';
        setTimeout(() => topbar.classList.add('shown'), 300);
    }

    closeBtn.addEventListener('click', () => {
        topbar.classList.remove('shown');
        topbar.classList.add('closed');
        sessionStorage.setItem('topbarClosed', 'true');
    });
});
